<template>
  <b-modal id="solution-modal" size="md" no-close-on-backdrop>
    <!-- custom modal title -->
    <template #modal-title>
      <div class="d-flex align-items-center">
        <feather-icon size="20" icon="InfoIcon" class="mr-05" />
        <span class="fs-18">Solusi Perbaikan</span>
      </div>
    </template>
    <!-- form container -->
    <loader-component v-if="is_loading" />
    <b-card no-body class="mb-0">
      <b-card-body>
        <validation-observer ref="scraperRules">
          <b-form>
            <b-form-group>
              <validation-provider #default="{ errors }" name="Scraper Name">
                <label for="problem_classification">
                  Klasifikasi Masalah <span class="text-danger">*</span>
                </label>
                <b-input-group>
                  <b-input-group-prepend is-text style="margin-right: -5px;">
                    <feather-icon icon="FolderIcon" />
                  </b-input-group-prepend>
                  <div class="scraper-dropdown" style="width: 27.1rem;">
                    <Dropdown
                      :options="options.problem_classification"
                      v-on:selected="classificationSelection"
                      :disabled="false"
                      :maxItem="10"
                      placeholder="Pilih Klasifikasi Masalah"
                    />
                  </div>
                </b-input-group>
                <small class="text-danger" style="font-size: 10px">{{
                  errors[0]
                }}</small>
              </validation-provider>
            </b-form-group>
            <b-form-group>
              <validation-provider
                #default="{ errors }"
                name="Solusi Perbaikan"
                rules="required"
              >
                <label for="problem_classification">
                  Solusi <span class="text-danger">*</span>
                </label>
                <b-form-textarea
                  id="solution"
                  placeholder="Solusi Perbaikan"
                  v-model="solution"
                  rows="8"
                />
                <small class="text-danger" style="font-size: 10px">{{
                  errors[0]
                }}</small>
              </validation-provider>
            </b-form-group>
            <!-- story_point -->
            <b-form-group>
              <validation-provider
                #default="{ errors }"
                name="Story Point"
                rules="required"
              >
                <label for="story_point">
                  Story Point <span class="text-danger">*</span>
                </label>
                <b-form-select
                  v-model="story_point"
                  id="story_point"
                  :options="story_point_options"
                />
                <small class="text-danger" style="font-size: 10px">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-form>
        </validation-observer>
      </b-card-body>
    </b-card>
    <!-- custom modal footer -->
    <template #modal-footer>
      <!-- button batal -->
      <b-button
        variant="outline-danger"
        size="sm"
        class="float-right mr-05"
        @click="cancelFixed"
      >
        Batal
      </b-button>
      <!-- button simpan -->
      <b-button
        variant="outline-info"
        size="sm"
        class="float-right"
        :disabled="!problem_classification"
        @click.prevent="setFixed"
      >
        Simpan
      </b-button>
    </template>
  </b-modal>
</template>
<script>
import {
  BModal,
  VBModal,
  BCard,
  BCardHeader,
  BCardTitle,
  BCardBody,
  BForm,
  BFormTextarea,
  BFormSelect,
  BFormGroup,
  BInputGroup,
  BInputGroupPrepend,
  BFormInput,
  BButton,
  BAlert,
} from "bootstrap-vue";
import Dropdown from "vue-simple-search-dropdown";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import useJwt from "@/auth/jwt/useJwt";
import floating_loader from "@/views/components/floatingLoader.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  name: "solutionModal",
  components: {
    ValidationProvider,
    ValidationObserver,
    BModal,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BForm,
    BFormTextarea,
    BFormSelect,
    BFormGroup,
    BInputGroup,
    BInputGroupPrepend,
    BFormInput,
    BButton,
    BAlert,
    Dropdown,
    "loader-component": floating_loader,
  },
  props: {
    id_scraper: {
      type: String,
      default: function() {
        return null;
      },
    },
  },
  data() {
    return {
      is_loading: false,
      username: this.$store.getters["data/user"].username,
      solution: "",
      story_point: null,
      problem_classification: null,
      story_point_options: [
        { value: null, text: "Pilih Story Point", disabled: true },
        { value: 1, text: "1 - Sangat Mudah" },
        { value: 2, text: "2 - Mudah" },
        { value: 3, text: "3 - Agak Mudah" },
        { value: 4, text: "4 - Sedang" },
        { value: 5, text: "5 - Agak Sulit" },
        { value: 6, text: "6 - Sulit" },
        { value: 7, text: "7 - Sangat Sulit" },
        { value: 8, text: "8 - Sangat Kompleks" },
      ],
      options: {
        problem_classification: [],
      },
      //   validation
      required,
    };
  },
  created() {
    this.getProblemClassification();
  },
  methods: {
    classificationSelection(data) {
      this.problem_classification = data.name;
    },
    getProblemClassification() {
      let params = {
        page: 1,
        item: 1000,
      };
      let query = Object.keys(params)
        .map((key) => key + "=" + params[key])
        .join("&");
      let api = process.env.VUE_APP_API_URL + "problem-classification?" + query;
      useJwt.axiosIns.get(api).then((res) => {
        this.options.problem_classification =
          res.data.problem_classification_data || [];
        this.options.problem_classification = this.options.problem_classification.map(
          (el) => ({
            id: el._id,
            name: el.name,
          })
        );
      });
    },
    setFixed() {
      this.$refs.scraperRules.validate().then((success) => {
        if (success) {
          this.is_loading = true;
          let api =
            process.env.VUE_APP_API_URL +
            "scraper-log/update/" +
            this.id_scraper;
          useJwt.axiosIns
            .put(api, {
              data: {
                status_to_update: "OnProgress",
                status: "Fixed",
                problem_classification: this.problem_classification,
                solution: this.solution,
                story_point: this.story_point,
              },
            })
            .then(() => {
              this.solution = "";
              this.story_point = null;
              this.$bvModal.hide("solution-modal");
              this.$parent.getData();
              this.$toast({
                component: ToastificationContent,
                position: "top-right",
                props: {
                  title: "Berhasil",
                  icon: "CheckCircleIcon",
                  variant: "success",
                  text: `Data berhasil diupdate`,
                },
              });
            })
            .catch((err) => {
              this.solution = "";
              this.story_point = null;
              this.$toast({
                component: ToastificationContent,
                position: "top-right",
                props: {
                  title: "Gagal",
                  icon: "XCircleIcon",
                  variant: "danger",
                  text: `Data gagal diupdate`,
                },
              });
            })
            .finally(() => {
              this.is_loading = false;
            });
        }
      });
    },
    cancelFixed() {
      this.solution = "";
      this.story_point = null;
      this.$bvModal.hide("solution-modal");
    },
  },
  directives: {
    "b-modal": VBModal,
  },
};
</script>
